import { defineStyle as t, defineStyleConfig as b } from "@chakra-ui/styled-system";
import { mode as r } from "@chakra-ui/theme-tools";
import { runIfFn as d } from "../utils/run-if-fn.mjs";
const s = t({
  lineHeight: "1.2",
  borderRadius: "3xl",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    color: "gray.200",
    cursor: "not-allowed",
    boxShadow: "none",
    _hover: {
      color: "gray.200"
    }
  }
}), l = t((o) => {
  const { colorScheme: e } = o;
  return e === "gray" ? {
    color: r("gray.800", "whiteAlpha.900")(o),
    _hover: {
      bg: r("gray.100", "whiteAlpha.200")(o)
    },
    _active: { bg: r("gray.200", "whiteAlpha.300")(o) }
  } : {
    color: r("".concat(e, ".500"), "".concat(e, ".300"))(o),
    bg: "transparent",
    _hover: {
      color: "".concat(e, ".300")
    }
  };
}), v = t((o) => {
  const { colorScheme: e } = o, a = r("gray.200", "whiteAlpha.300")(o);
  return {
    border: "1px solid",
    borderColor: e === "gray" ? a : "currentColor",
    ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": { marginEnd: "-1px" },
    ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": { marginBottom: "-1px" },
    ...d(l, o)
  };
}), m = t((o) => {
  const { colorScheme: e } = o;
  return e === "gray" ? {
    color: "inherit",
    bg: "transparent",
    _hover: {
      bg: "whiteAlpha.200"
    },
    _active: { bg: "whiteAlpha.300" }
  } : {
    color: r("".concat(e, ".500"), "".concat(e, ".300"))(o),
    bg: "transparent",
    _hover: {
      bg: "whiteAlpha.200"
    },
    _active: { bg: "whiteAlpha.300" }
  };
}), y = t((o) => {
  const { colorScheme: e } = o;
  return e === "gray" ? {
    color: "inherit",
    bg: "transparent",
    _hover: {
      bg: "coldAlpha.200"
    },
    _active: { bg: "coldAlpha.300" }
  } : {
    color: r("".concat(e, ".500"), "".concat(e, ".300"))(o),
    bg: "transparent",
    _hover: {
      bg: "coldAlpha.200"
    },
    _active: { bg: "coldAlpha.300" }
  };
}), u = t((o) => {
  const { colorScheme: e } = o;
  return e === "gray" ? {
    color: "inherit",
    bg: "transparent",
    border: "10px solid",
    borderColor: "coldAlpha.200",
    _hover: {
      bg: "coldAlpha.200"
    },
    _active: { bg: "coldAlpha.300" }
  } : {
    color: r("".concat(e, ".500"), "".concat(e, ".300"))(o),
    bg: "transparent",
    _hover: {
      bg: "coldAlpha.200"
    },
    _active: { bg: "coldAlpha.300" }
  };
}), _ = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
}, w = t((o) => {
  var n;
  const { colorScheme: e } = o;
  if (e === "gray") {
    const i = r("gray.100", "whiteAlpha.200")(o), h = r("gray.200", "whiteAlpha.300")(o), g = r("gray.300", "whiteAlpha.400")(o);
    return {
      bg: i,
      boxShadow: "none",
      _hover: {
        bg: h,
        _disabled: {
          bg: i
        }
      },
      _active: {
        bg: g,
        boxShadow: "none",
        _disabled: {
          boxShadow: "none"
        }
      }
    };
  }
  const { bg: a = "".concat(e, ".500"), color: c = "white" } = (n = _[e]) != null ? n : {};
  return {
    bg: r(a, "".concat(e, ".300"))(o),
    boxShadow: "none",
    color: r(c, "gray.800")(o),
    bgGradient: "linear(to-r, primary.from, primary.to)",
    _hover: {
      bg: "".concat(e, ".300")
    },
    _disabled: {
      color: "white",
      bg: "gray.200",
      _hover: {
        color: "white",
        bg: "gray.200"
      }
    },
    _active: {
      boxShadow: "none",
      _disabled: {
        boxShadow: "none"
      },
      _focusVisible: {
        boxShadow: "outline"
      }
    }
  };
}), S = t((o) => {
  const { colorScheme: e } = o;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: r("".concat(e, ".500"), "".concat(e, ".200"))(o),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: r("".concat(e, ".500"), "".concat(e, ".300"))(o)
    }
  };
}), f = t({
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: "0",
  p: "0"
}), x = {
  ghost: l,
  outline: v,
  solid: w,
  angel: m,
  daemon: y,
  link: S,
  unstyled: f,
  bigBorder: u
}, A = {
  lg: t({
    h: "12",
    minW: "12",
    fontSize: "lg",
    px: "6"
  }),
  md: t({
    h: "10",
    minW: "10",
    fontSize: "md",
    px: "4"
  }),
  sm: t({
    h: "8",
    minW: "8",
    fontSize: "sm",
    px: "3"
  }),
  xs: t({
    h: "6",
    minW: "6",
    fontSize: "xs",
    px: "2"
  })
}, B = b({
  baseStyle: s,
  variants: x,
  sizes: A,
  defaultProps: {
    variant: "outline",
    //here we override all default values defined in the variants
    size: "md",
    colorScheme: "primary"
  }
});
export {
  B as buttonTheme
};
